import { createFileRoute } from "@tanstack/react-router";
import { getSettingsSubPageColors } from "~/components/settingsSubPageColors";
import { myProfileQueryOptions } from "~/features/myProfile/api";
import { EmailChangeTemplate } from "~/features/myProfile/EmailChangeTemplate";
import { cn } from "~/lib/cn";

// MyProfileTemplate（layout）の上に全画面オーバーレイで重ねる。
// 中身は PageContainer（min-h-screen・自前スクロールなし）でページスクロール前提のため、
// fixed の overlay 自体を overflow-y-auto でスクロール可能にする。
const EmailPage = () => (
  <div
    className={cn(
      "fixed inset-0 z-40 overflow-y-auto overscroll-contain",
      getSettingsSubPageColors().emailOverlayBg,
    )}
  >
    <EmailChangeTemplate />
  </div>
);

export const Route = createFileRoute("/_authenticated/my-page/email")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(myProfileQueryOptions),
  component: EmailPage,
});
